import React from 'react';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import ContentEditable from 'react-contenteditable';
import { renameInventory, updateInventoryRequest } from '../../../store/slices/boardSlice';
import s from './Title.module.css';

// Using this component with useState doesn't work. So I used the class library component.

class Title extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: this.props.titleText,
            changedTitle: this.props.titleText,
        };
        this.saveTitle = this.saveTitle.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.placeCaretAtEnd = this.placeCaretAtEnd.bind(this);
        this.contentEditable = React.createRef();
    }

    componentDidMount() {
        if (this.props.isCopyInventoryMode) {
            this.placeCaretAtEnd();
        }
    }

    onChange(e) {
        this.setState({
            changedTitle: e.target.value
                .replace(/<\/?\w+>/gm, '')
                .replace(/&\w+;/gm, ' ')
                .substring(0, 255),
        });
    }

    onBlur() {
        if (this.state.changedTitle.trim() === '') {
            this.setState((prevState) => ({ changedTitle: prevState.text }));
            this.saveTitle(this.state.text);
        } else {
            this.setState((prevState) => ({
                text: prevState.changedTitle,
                changedTitle: prevState.changedTitle.trim(),
            }));
            this.saveTitle(this.state.changedTitle.trim());
        }
    }

    saveTitle(title) {
        this.props.dispatch(
            renameInventory({
                warehouseId: this.props.warehouseId,
                inventoryGuid: this.props.inventoryGuid,
                title,
            })
        );
        this.props.dispatch(
            updateInventoryRequest({
                body: JSON.stringify({ title }),
                inventoryGuid: this.props.inventoryGuid,
            })
        );
    }

    placeCaretAtEnd() {
        const el = this.contentEditable.current;
        el.focus();
        if (
            typeof window.getSelection !== 'undefined' &&
            typeof document.createRange !== 'undefined'
        ) {
            const range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange !== 'undefined') {
            const textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    }

    render() {
        return (
            <div>
                {this.props.hasFullAccess && (
                    <ContentEditable
                        innerRef={this.contentEditable}
                        html={this.state.changedTitle}
                        disabled={false}
                        onChange={(e) => {
                            this.onChange(e);
                        }}
                        tagName="div"
                        className={s.title}
                        data-id="inventory-title"
                        onBlur={this.onBlur}
                        onPaste={(e) => {
                            e.preventDefault();
                            const text = e.clipboardData.getData('text/plain');
                            document.execCommand('insertText', false, text);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.currentTarget.blur();
                            }
                        }}
                    />
                )}
                {!this.props.hasFullAccess && (
                    <h3 className={cx(s.titleText)}>{this.props.titleText}</h3>
                )}
            </div>
        );
    }
}

export function TitleContainer(props) {
    const dispatch = useDispatch();
    const isCopyInventoryMode = useSelector((state) => state.inventory.isCopyMode);

    return (
        <Title
            {...props}
            renameInventory={renameInventory}
            dispatch={dispatch}
            isCopyInventoryMode={isCopyInventoryMode}
        />
    );
}
